import { combineReducers } from 'redux';
import commonReducer, { CommonStoreKey } from './commonStore/reducer';
import callAPIReducer, { callAPIStoreKey } from './callAPI/reducer';

const combinedReducer = combineReducers({
    [callAPIStoreKey]: callAPIReducer,
    [CommonStoreKey]: commonReducer
});

function getStateWithImpersonateUser(state) {
    return {
        CommonStore: {
            impersonateUser: { ...state.CommonStore.impersonateUser },
            appLevelPermissions: state.CommonStore.appLevelPermissions ? { ...state.CommonStore.appLevelPermissions } : null
        }
    };
}

function getStateWithAppLevelPermission(state) {
    return {
        CommonStore: {
            appLevelPermissions: state.CommonStore.appLevelPermissions ? { ...state.CommonStore.appLevelPermissions } : null,
            impersonateUser: state.CommonStore.impersonateUser ? { ...state.CommonStore.impersonateUser } : null
        }
    };
}

export const reducers = (state, action) => {
    if (action.type === 'APIData/removeStoreData') {
        if (action.payload && state.CommonStore.impersonateUser !== null) {
            state = getStateWithImpersonateUser(state);
        } else if (action.payload) {
            state = getStateWithAppLevelPermission(state);
        } else {
            state = undefined;
        }
    }
    return combinedReducer(state, action);
};

export default combinedReducer;
